import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPlacesBlock } from '../../api/fetch-places-block';

export const fetchPlacesBlockThunk = createAsyncThunk(
    'fetchPlacesBlock',
    async () => fetchPlacesBlock(),
);
